import type { ReactNode } from 'react';
import { STATIC_BASE } from '@lib/runtimeConfig';
import { useTranslation } from '@hooks/useTranslation';
import { LocaleSwitcher } from '@components/LocaleSwitcher/LocaleSwitcher';
import styles from './EorAuthLayout.module.scss';

// Decorative social-proof pills over the hero (marketing copy — not real data).
const PILLS = [
  { code: 'nigeria', name: 'John Okeke', amount: 'NGN 2,000,000' },
  { code: 'kenya', name: 'Felix Njeri', amount: 'Kes 350,000' },
  { code: 'uganda', name: 'Alex Akiki', amount: 'UGX 681,500' },
  { code: 'tanzania', name: 'John Okeke', amount: 'NGN 2,000,000' },
  { code: 'ghana', name: 'John Okeke', amount: 'NGN 2,000,000' },
];

export function EorAuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const img = `${STATIC_BASE}/images/eor-login`;

  return (
    <div className={styles.split}>
      <div className={styles.left}>
        <div className={styles.logoRow}>
          <img src={`${img}/workpay-logo.svg`} alt="Workpay" className={styles.logo} />
        </div>
        <div className={styles.localeRow}>
          <LocaleSwitcher />
        </div>
        <div className={styles.content}>
          <div className={styles.contentInner}>{children}</div>
        </div>
      </div>

      <div className={styles.right} aria-hidden="true">
        <img src={`${img}/login-bg.png`} alt="" className={styles.hero} />
        <div className={styles.overlay} />
        <div className={styles.rightContent}>
          <p className={styles.tagline}>
            {t('K_DS_EXT_EOR_TAGLINE', 'Hire, manage and pay your global team easily.')}
          </p>
          <div className={styles.pills}>
            {PILLS.map((p, i) => (
              <span className={styles.personPill} key={`${p.code}-${i}`}>
                <img src={`${img}/flags/${p.code}.png`} alt="" className={styles.flag} />
                <span className={styles.personText}>
                  <span className={styles.personName}>{p.name}</span>
                  <span className={styles.personAmount}>{p.amount}</span>
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
